"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundingSpecV1 = exports.formatQuantity = exports.formatPercentage = exports.formatMinutes = exports.aggregate = exports.computeLine = exports.CalculationPolicyV1 = exports.Decimal = void 0;
var decimal_js_1 = require("decimal.js");
Object.defineProperty(exports, "Decimal", { enumerable: true, get: function () { return decimal_js_1.Decimal; } });
__exportStar(require("./types"), exports);
__exportStar(require("./registry"), exports);
var v1_1 = require("./policies/v1");
Object.defineProperty(exports, "CalculationPolicyV1", { enumerable: true, get: function () { return v1_1.CalculationPolicyV1; } });
var v1_2 = require("./policies/v1");
Object.defineProperty(exports, "computeLine", { enumerable: true, get: function () { return v1_2.computeLine; } });
Object.defineProperty(exports, "aggregate", { enumerable: true, get: function () { return v1_2.aggregate; } });
Object.defineProperty(exports, "formatMinutes", { enumerable: true, get: function () { return v1_2.formatMinutes; } });
Object.defineProperty(exports, "formatPercentage", { enumerable: true, get: function () { return v1_2.formatPercentage; } });
Object.defineProperty(exports, "formatQuantity", { enumerable: true, get: function () { return v1_2.formatQuantity; } });
Object.defineProperty(exports, "roundingSpecV1", { enumerable: true, get: function () { return v1_2.roundingSpecV1; } });
//# sourceMappingURL=index.js.map